<template>
  <div class="logosDiv">
    <div class="row">
      <div class="col-12" style="padding-left: 15px;">
        <div class="element-info-text">
          <span>{{ t('businessUnitManageImagesDesc', 'businessUnitManageImagesDesc') }} </span>
          <button class="btn btn-primary" v-b-toggle.uploadLogo>{{ t('businessUnitUploadMoreLogos','businessUnitUploadMoreLogos') }}</button>
        </div>
      </div>
    </div>
    <hr>
    <b-collapse class="row" id="uploadLogo">
      <form class="col-12 row padding-fix" v-on:submit.prevent="uploadBusinessUnitLogo">
          <div class="col-12 upload-div form-group">
            <b-form-file accept=".jpg, .png" v-model="uploadedLogo" class="upload-input"></b-form-file>
            <button class="btn btn-secondary ml-4" :disabled="!this.uploadedLogo" required>{{ t('uploadLogoBtnText', 'uploadLogoBtnText') }}</button>
          </div>
      </form>
      <form class="col-12 row padding-fix" v-on:submit.prevent="uploadBusinessUnitBackground">
          <div class="col-12 upload-div mb-0 form-group">
            <b-form-file accept=".jpg, .png" v-model="uploadedBackground" class="upload-input"></b-form-file>
            <button class="btn btn-secondary ml-4" :disabled="!this.uploadedBackground" required>{{ t('uploadBackgroundBtnText', 'uploadBackgroundBtnText') }}</button>
          </div>
      </form>
      <ResponseInfo v-if="getResponseInfo.responseName == 'businessUnitUpload'" class="mt-3" />
      <hr class="col-12">
    </b-collapse>
    <div class="col-12 padding-fix mb-4">
      <button v-bind:class="{'btn-primary' : (this.showingType == 'logos'), 'btn-dark' : (this.showingType == 'backgrounds')}" class="btn" @click="toggleVisibleLogos">{{ t('showLogosBtnText', 'showLogosBtnText') }}</button>
      <button v-bind:class="{'btn-dark' : (this.showingType == 'logos'), 'btn-primary' : (this.showingType == 'backgrounds')}" class="btn" @click="toggleVisibleBackgrounds">{{ t('showBackgroundsBtnText', 'showBackgroundsBtnText') }}</button>
    </div>
    <div class="col-sm-12 row padding-fix" v-if="showingType == 'logos'">
      <div class="col-sm-12 col-md-2 col-lg-2 logo-block" v-for="logo in getAvailableBusinessUnitLogos" v-bind:key="logo.basename">
        <div class="logo-box">
          <img class="logo-img" :src="getImgUrl(logo.basename, 'businessUnitLogos')" :alt="logo.basename" />
          <button class="btn btn-danger logo-box-btn" @click="deleteBusinessUnitLogo(logo.basename, 'businessUnitLogos')">{{ t('deleteBtnText', 'deleteBtnText') }}</button>
        </div>
      </div>
    </div>
    <div class="col-sm-12 row padding-fix" v-if="showingType == 'backgrounds'">
      <div class="col-sm-12 col-md-2 col-lg-2 logo-block" v-for="logo in getAvailableBusinessUnitBackgrounds" v-bind:key="logo.basename">
        <div class="logo-box">
          <img class="logo-img" :src="getImgUrl(logo.basename, 'businessUnitBackgrounds')" :alt="logo.basename" />
          <button class="btn btn-danger logo-box-btn" @click="deleteBusinessUnitLogo(logo.basename, 'businessUnitBackgrounds')">{{ t('deleteBtnText', 'deleteBtnText') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResponseInfo from '@/components/ResponseInfo'
import { clientShortName } from '@/helpers/clientShortName.js'
import { awsUrl } from '@/helpers/awsUrl.js'
import { mapGetters } from 'vuex'

export default {
  name: 'BusinessUnitsNavbarImages',
  data() {
    return {
      uploadedLogo: null,
      uploadedBackground: null,
      showingType: 'logos'
    }
  },
  components: {
    ResponseInfo
  },
  methods: {
    uploadBusinessUnitLogo(event) {
      let businessUnitLogo = this.uploadedLogo
      let formData = new FormData();

      formData.append('businessUnitLogos', businessUnitLogo)
      formData.append('type', 'businessUnitLogos')
      this.$store.dispatch('uploadBusinessUnitImage',formData)

      this.uploadedLogo = null
    },
    uploadBusinessUnitBackground() {
      let businessUnitBackground = this.uploadedBackground
      let formData = new FormData();

      formData.append('businessUnitBackgrounds', businessUnitBackground)
      formData.append('type', 'businessUnitBackgrounds')
      this.$store.dispatch('uploadBusinessUnitImage',formData)

      this.uploadedBackground = null
    },
    deleteBusinessUnitLogo(logoName, type) {
      this.$store.dispatch('deleteBusinessUnitImage', {
        type: type,
        logoName: logoName
      })
      // get logos afterwards
    },
    getImgUrl(logo, type) {
      return awsUrl() + type + '/' + logo
    },
    getAvailableLogos() {
      this.$store.dispatch('getAvailableBusinessUnitLogos')
    },
    getAvailableBackgrounds() {
      this.$store.dispatch('getAvailableBusinessUnitBackgrounds')
    },
    toggleVisibleLogos() {
        this.showingType = 'logos'
    },
    toggleVisibleBackgrounds() {
      this.showingType = 'backgrounds'
    }
  },
  computed: {
    ...mapGetters(['allTemplateDetails', 'getAvailableBusinessUnitLogos', 'getAvailableBusinessUnitBackgrounds', 'getResponseInfo'])
  },
  created() {
    if(!this.$store.getters.getAvailableBusinessUnitLogos || !this.$store.getters.getAvailableBusinessUnitLogos.length > 0) {
      this.getAvailableLogos()
    }
    if(!this.$store.getters.getAvailableBusinessUnitBackgrounds || !this.$store.getters.getAvailableBusinessUnitBackgrounds.length > 0) {
      this.getAvailableBackgrounds()
    }
  }
}
</script>

<style scoped>
  #uploadLogo {
    padding: 0px 15px 5px 15px;
  }
  .logosDiv {
    padding: 15px;
  }
  .upload-input {
    max-width: 300px;
  }
  .padding-fix {
    padding: 0px;
  }
  .logo-block {
    max-height: 250px;
  }
  .logo-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
  .logo-box {
    position: relative;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo-box-btn {
    position: absolute;
    width: 150px;
    bottom: 10px;
    z-index: 5;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }
</style>